import React from 'react';
import Image1 from '../../assest/homestay/4.jpeg'
import Image2 from '../../assest/homestay/2.jpeg'
import Image3 from '../../assest/farmstay/67.jpg'
import Image4 from '../../assest/farmstay/46.jpeg'
import './architecturalgallery.scss'

const Architecturalgallery = () =>
{
	return (
		<section className="architectural-details-section">
			<h2 className="section-title">Explore Our Stays</h2>
			<div className="grid-container">
				<div className="grid-item large-living-room">
					<img src={Image1} alt="Modern living room with minimalist white furniture and large windows" />
				</div>
				<div className="grid-item large-bedroom">
					<img src={Image2} alt="Luxury master bedroom with floor to ceiling windows" />
				</div>
				<div className="grid-item small-kitchen">
					<img src={Image3} alt="Contemporary white kitchen with marble countertops" />
				</div>
				<div className="grid-item small-bathroom">
					<img src={Image4} alt="Detail of high-end bathroom with freestanding tub" />
				</div>
			</div>
		</section>
	);
};

export default Architecturalgallery;